import { defaultRoutes } from './default';
import { integrationRoutes } from './integration';

export const MyRoutes = [...defaultRoutes, ...integrationRoutes];
